export const FOTBOLL_PLAY_TEAM_ADMIN_ABBRVS = ['MFF'] as const;

export function isFotbollPlayTeamAdminAbbrv(teamAbbrv?: string): boolean {
  return !!teamAbbrv && (FOTBOLL_PLAY_TEAM_ADMIN_ABBRVS as readonly string[]).includes(teamAbbrv);
}

export function canAccessFotbollPlay(params: {
  teamAbbrv?: string;
  isSuperAdmin: boolean;
  hasTeamAccess: (teamAbbrv: string) => boolean;
}): boolean {
  if (params.isSuperAdmin) {
    return true;
  }

  const { teamAbbrv } = params;
  return !!teamAbbrv && isFotbollPlayTeamAdminAbbrv(teamAbbrv) && params.hasTeamAccess(teamAbbrv);
}
